module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIABkAGQMBIgACEQEDEQH/xAAXAAEBAQEAAAAAAAAAAAAAAAABAAIH/9oACAEBAAAAAOZFopJyzn//xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAIAQIQAAAAwN//xAAVAQEBAAAAAAAAAAAAAAAAAAAABv/aAAgBAxAAAACjH//EAB8QAAAFBAMAAAAAAAAAAAAAAAABEBEgEkFSYmFxwf/aAAgBAQABPwBX1g+sKuBmC8Fi7T//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AB//2Q=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/dark_cherry.jpg
// module id = gqVz
// module chunks = 14